import React from "react";

import { translate as t } from "infrastructure/translate/localization";

import BenefitsDetails from "../BenefitsDetails";

export function getColumns() {
  return [
    { id: "legalId", label: t("common-messages.nif-nie") },
    { id: "name", label: t("common-messages.name-and-surname") },
  ];
}

export function getData({ data, searchTerm }) {
  return data
    ?.filter(({ employee: { legalId, name, surname } }) => {
      const _searchTerm = searchTerm?.toLowerCase();
      const _name = name?.toLowerCase() + surname?.toLowerCase();
      return legalId?.includes(_searchTerm) || _name?.includes(_searchTerm);
    })
    ?.map(({ employee, benefits }) => {
      return {
        id: employee?.id,
        legalId: employee?.legalId,
        name: `${employee?.name} ${employee?.surname}`,
        breakDownContent: <BenefitsDetails benefits={benefits} />,
      };
    });
}
